import Vue from 'vue'
import Vuex from 'vuex'
import constants from '@/data/constants'

function hex2string(hex) {
  var i = 0;
  var ascii = "";
  while (i < hex.length / 2) {
    ascii = ascii + String.fromCharCode(parseInt(hex.substr(i * 2, 2), 16));
    i++;
  }
  return ascii;
}
export const CommonMixin = {
  data() {
    return {
      //     c_user:  this.$store.state.profile
      constants: constants,
    }
  },
  computed: {
    c_user() {
      if (this.$store.state.profile) {
        return this.$store.getters.getProfile
      } else {
        this.$store.dispatch(USER_REQUEST)
        return this.$store.getters.getProfile
      }
    }
  },
  methods: {
    getInstitutionName(id) {
      const i = this.$store.state.contacts.find(i => i.id == id)
      if (i) {
        return i.name
      } else {
        return 'institution not found'
      }
    },
    // findPositionByAtribute(array, attr, value) {
    //   for(var i = 0; i < array.length; i += 1) {
    //       if(array[i][attr] === value) {
    //           return i;
    //       }
    //   }
    //   return -1;
    // },
    dimension_formatted(a) {
      console.log('dimension_formatted')
      var out = ' '
      if (a.dim_height != null && a.dim_width != null) {
        console.log('1AAAA')
        out = out + (`${a.dim_height} x ${a.dim_width}`)

        console.log(a.dim_height)
        console.log(a.dim_width)
        console.log(out)

        if (a.dim_depth != null && a.dim_depth != '') {
          out = out + (` x ${a.dim_depth}`)
        }
        out = out + (' cm')

        if (a.dim_diameter != null && a.dim_diameter != '') {
          console.log('a.dim_diameter')
          console.log(a.dim_diameter)
          out = out + ' Ø ' + a.dim_diameter + ' cm'
        }

      } else {
        console.log('BBBBB')

        if (a.dim_diameter != null && a.dim_diameter != '') {
          out = out + (' Ø ' + a.dim_diameter)
          if (a.dim_depth != null && a.dim_depth != '') {
            out = out + (' cm')
          } else {
            out = out + (' x ')
          }
          console.log('dim_depth')
          console.log(out)
        }

        if (a.dim_depth != null) {
          out = out + (a.dim_depth + ' cm')
          console.log('dim_diameter')
          console.log(out)
        }
      }

      if (a.dimensions_notes != null && a.dimensions_notes != '') {
        out = out + (a.dimensions_notes)
        console.log('dimensions_notes')
        console.log(out)
      }

      if (a.dim_frame_width != null && a.dim_frame_height != null) {
        if (hex2string(out[0]) != null) {
          out = out + (', ')
        }
        console.log('hex2string')
        console.log(out)
        out = out + (a.dim_frame_height + ' x ' + a.dim_frame_width)
        if (a.dim_frame_depth != null && a.dim_frame_depth != '') {
          out = out + (' x ' + a.dim_frame_depth)
          console.log('dim_frame_depth')
          console.log(out)
        }
        out = out + (' cm' + ' (framed)')
      }
      console.log('out222')
      console.log(out)
      if ((a.dim_height != null && a.dim_width != null)
        && (a.dim_frame_width != null
          && a.dim_frame_height != null)
        && a.dimensions_notes != null && a.dim_diameter != null) {
        out = out + ('<br />')
      }

      var out2 = out != null ? out.replace('<br />', "\n").strip : ''
      console.log('out')
      console.log(out)
      out2 = out.replace('<br>', "\n")
      console.log('out2')
      console.log(out2)
      return out2
    },
    /// requires array of values to sort by as second argument
    customDoubleSort(array, sortValues, customSortField, regularSortField) {
      return array.sort(function (a, b) {
        if (sortValues.indexOf(a[customSortField]) < sortValues.indexOf(b[customSortField])) return -1;
        if (sortValues.indexOf(a[customSortField]) > sortValues.indexOf(b[customSortField])) return 1;
        if (a[regularSortField] > b[regularSortField]) return 1;
        if (a[regularSortField] < b[regularSortField]) return -1;
        return 0;
      });
    },
    // customSort (array, sortValues, field) {
    //   return array.sort((a, b) => sortValues.indexOf(a[field]) - sortValues.indexOf(b[field]));
    // },
    value2string(value, field) {
      var out = ''
      switch (field) {
        case 'invoice_signed':
        case 'including_slide':
        case 'including_film':
        case 'including_light':
        case 'including_computer':
        case 'including_other':
        case 'including_objects':
        case 'including_sound':
        case 'including_performance':
        case 'deaccessioned':
          out = value === '1' ? 'YES' : 'NO'
          break
        case 'type_of_work':
          out = this.constants.TYPES_OF_WORK.find(a => a.id == value).name
          break
        case 'visa_status':
          out = this.constants.VISA_STATUSES.find(a => a.id == value).name
          break
        case 'artist':
          out = this.$store.state.artists.find(a => a.id == value).name
          break
        case 'artwork_location_id':
          var a = this.$store.state.locations.find(a => a.id == value)
          out = a ? a.name : 'location not found'
          break
        default:
          out = value
          break
      }
      return out
    },
    snake2title(t) {
      if (t) {
        var s = t.split('_')
        for (var i = 0; i < s.length; i++) {
          s[i] = s[i][0].toUpperCase() + s[i].slice(1)
        }
        return s.join(' ')
      } else {
        return ''
      }
    },
    getDecade(year) {
      return (Math.floor(year / 10) * 10) + 's';
    },
    formatMoney(amount) {
      let thousands = ','
      let decimal = '.'
      let decimalCount = 2
      let amountF = parseFloat(amount)
      try {
        // decimalCount = Math.abs(decimalCount)
        // decimalCount = isNaN(decimalCount) ? 2 : decimalCount
        let i = parseInt(amountF = Math.abs(Number(amountF) || 0).toFixed(decimalCount)).toString()
        let j = (i.length > 3) ? i.length % 3 : 0
        return (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amountF - i).toFixed(decimalCount).slice(2) : '')
      } catch (e) {
        // console.log(e)
      }
    },
    nl2br(str, is_xhtml) {
      var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>'
      return (str + '').replace(
        /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
        '$1' + breakTag + '$2'
      )
    },
    humanize(t) {
      return t.replace(/_/g, ' ').replace(/(?: |\b)(\w)/g, function (t) {
        return t.toUpperCase()
      })
    },
    isImage(filename) {
      return ['png', 'PNG', 'eps', 'EPS', 'gif', 'GIF', 'bmp', 'BMP', 'JPG', 'jpg', 'peg', 'PEG', 'IFF', 'iff', 'TIF', 'tif'].includes(filename.substr(filename.length - 3))
    },
    exportHTML(text, title) {
      const ltitle = title || text.title || 'TextDownload'
      const content = text.content || text ? text : 'Text Content not provided'
      this.composeHTML(content, ltitle)
    },
    composeHTML(content, title) {
      var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
        "xmlns:w='urn:schemas-microsoft-com:office:word' " +
        "xmlns='http://www.w3.org/TR/REC-html40'>" +
        "<head><meta charset='utf-8'><title>" + title + '</title></head><body>'
      var footer = '</body></html>'
      // var sourceHTML = header + document.getElementById("source-html").innerHTML + footer
      var sourceHTML = header + content + footer
      var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML)
      var fileDownload = document.createElement('a')
      document.body.appendChild(fileDownload)
      fileDownload.href = source
      fileDownload.download = title + '.doc'
      fileDownload.click()
      document.body.removeChild(fileDownload)
    },
    stripHtml(s) {
      return s.replace(/<\/?[^>]+(>|$)/g, ' ')
    },
    capitalize(s) {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
    o2ids(array, prop) {
      return array.map(a => a[prop])
    },
    ids2o(array) {
      var objs = Object.assign([], this.$store.state.artworks)
      // console.log(objs)
      var out = objs.filter(a => {
        // console.log(array.includes(a.id))
        return (array.includes(a.id))
      })
      return out
    },
    get_user(userId) {
      if (this.$store.state.users && this.$store.state.users.length > 0) {
        var user = this.$store.state.users.find(u => u.id === userId)
        if (user) {
          return `${user.firstname} ${user.lastname}`
        } else {
          return '??'
        }
      }
    },
    get_contact(id) {
      if (this.$store.state.contacts && this.$store.state.contacts.length > 0) {
        var c = this.$store.state.contacts.find(u => u.id === id)
        if (c) {
          return c.name
        } else {
          return 'not found'
        }
      }
    },
    get_abb(userId) {
      if (this.$store.state.users && this.$store.state.users.length > 0 && userId > 0) {
        var user = this.$store.state.users.find(u => u.id === userId)
        if (user) {
          return `${user.abb}`
        } else {
          return 'unknown'
        }
      }
    },
    get_visa_status(visa_status) {
      if (visa_status != undefined) {
        var vss = this.constants.VISA_STATUSES.filter(
          vs => vs.id === visa_status
        )
        if (vss[0] != undefined) {
          // console.log(vss[0].id)
          return vss[0].id > 0 ? vss[0].name : ''
        } else {
          return ''
        }
      }
    },
    get_location_name(id) {
      if (id != 465) {
        var l = this.$store.state.locations.find(l => l.id === id)
        return l ? `${l.disabled == 1 ? 'DELETED — ' : ''}${l.name}` : ''
      }
    },

    get_artist_gender(id) {
      if (id != 465) {
        var l = this.$store.state.artists.find(l => l.id === id)
        return l ? l.gender : ''
      }
    },

    get_artist_nationality(id) {
      if (id != 465) {
        var l = this.$store.state.artists.find(l => l.id === id)
        return l ? (l.nationality != null && l.nationality != '' && l.nationality != 0 && l.nationality != "0") ? l.nationality : '' : ''
      }
    },

    get_artist_birth_year(id) {
      if (id != 465) {
        var l = this.$store.state.artists.find(l => l.id === id)
        return l ? l.birth_year : ''
      }
    },

    get_artist_death_year(id) {
      if (id != 465) {
        var l = this.$store.state.artists.find(l => l.id === id)
        return l ? l.death_year : ''
      }
    },

    get_artist_decade(id) {
      if (id != 465) {
        var l = this.$store.state.artists.find(l => l.id === id)
        return l ? l.birth_date ? this.getDecade(new Date(l.birth_date).getFullYear()) : '' : ''
      }
    },

    formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    getLatestInsurance(id) {
      var l = this.$store.state.artwork_insurance_logs.filter(l => l.artwork_id === id && l.market_insurance === 'insurance')
      if (l.length > 0) {
        l = this.sort_by_date(l, 'insurance_value_date')[0]
        return l
      } else {
        return ''
      }
    },
    getLatestInsuranceValueText(id) {
      var l = this.getLatestInsurance(id)
      // var l = this.$store.state.artwork_insurance_logs.filter(l => l.artwork_id === id)
      // console.log(this.$store.state.artwork_insurance_logs.length)
      // console.log(l)
      if (l && l.insurance_value != null) {
        // l = this.sort_by_date(l, 'change_date')[0]
        var date = l.insurance_value_date ? `(${l.insurance_value_date})` : ''
        var currency = l.insurance_value_currency ? l.insurance_value_currency : ''
        return `${this.formatNumber(l.insurance_value)} ${currency} `
      } else {
        return ''
      }
    },
    getLatestInsuranceValue(id) {
      var l = this.getLatestInsurance(id)
      // var l = this.$store.state.artwork_insurance_logs.filter(l => l.artwork_id === id)
      // console.log(this.$store.state.artwork_insurance_logs.length)
      // console.log(l)
      if (l) {
        // l = this.sort_by_date(l, 'change_date')[0]
        return l.insurance_value
      } else {
        return ''
      }
    },
    getLatestInsuranceCurrency(id) {
      var l = this.getLatestInsurance(id)
      // var l = this.$store.state.artwork_insurance_logs.filter(l => l.artwork_id === id)
      // console.log(this.$store.state.artwork_insurance_logs.length)
      // console.log(l)
      if (l) {
        // l = this.sort_by_date(l, 'change_date')[0]
        return l.insurance_value_currency
      } else {
        return ''
      }
    },

    sort_by_date(datas, field) {
      // console.log(datas)
      datas.sort((a, b) => {
        const dateA = new Date(a[field]);
        const dateB = new Date(b[field]);

        // subtract dates to get a value that's either negative, positive, or zero
        return dateB - dateA;  // sort in descending order
      });
      return datas
    },

    get_exhibition_name(id) {
      if (id) {
        var l = this.$store.state.exhibitions.find(l => l.id === id)
        return l ? l.name : ''
      } else {
        return ''
      }
    },
    getOwnershipName(o) {
      // console.log(this.constants)
      var out = this.constants.OWNERSHIPS.find(s => s.id == o)
      if (out) {
        return out.name
      } else {
        return 'Ownership NOT SET'
      }
    },
    getArtwork(artworkId) {
      if (this.$store.state.artworks.length > 0) {
        var artwork = this.$store.state.artworks.find(u => u.id === artworkId)
        if (artwork) {
          return `${artwork.name}, ${artwork.title}, ${artwork.accession_number}`
        } else {
          return 'Not found'
        }
      }
    },
    getUser(userId) {
      if (this.$store.state.users.length > 0) {
        var user = this.$store.state.users.find(u => u.id === userId)
        if (user) {
          return `${user.firstname} ${user.lastname}`
        } else {
          return '??'
        }
      }
    },
    format_date(date, format = 'YYYY-MM-DD') {
      var moment = require('moment')
      var ndate = new Date(date)
      return moment(ndate).format(format)
    },
    findMinMax(arr) {
      // console.log(arr)
      let max = arr[0].id
      for (let i = 1, len = arr.length; i < len; i++) {
        let v = arr[i].id
        max = (v > max) ? v : max
      }
      return max
    },
    formatAddress(address) {
    }
  },
  filters: {
    formattedAddress(address) {
      return this.formatAddress(address)
    }
  }
}

export default CommonMixin


// getVisaStatus (vs) {
//   var out = this.constants.VISA_STATUSES.find(s => s.id == vs)
//   if (out) {
//     return out.name
//   } else {
//     return 'Visa status unknown'
//   }
// },



// WEBPACK FOOTER //
// ./src/mixins/CommonMixin.js